module.exports = __webpack_public_path__ + "img/jordan.75131e80.svg";